import { render, staticRenderFns } from "./ExceptionCard.vue?vue&type=template&id=42bf77ee&"
import script from "./ExceptionCard.vue?vue&type=script&lang=js&"
export * from "./ExceptionCard.vue?vue&type=script&lang=js&"
import style0 from "./ExceptionCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports